var exports = {
  "Ew": "MessageAttachments.module__forwardedContainer___TV9XLX",
  "iE": "MessageAttachments.module__forwardedBar___TV9XLX",
  "Q$": "MessageAttachments.module__forwardedContent___TV9XLX",
  "Sd": "MessageAttachments.module__forwardedHeader___TV9XLX",
  "Q_": "MessageAttachments.module__forwardedIcon___TV9XLX",
  "nQ": "MessageAttachments.module__forwardedLabel___TV9XLX",
  "KK": "MessageAttachments.module__attachmentsContainer___TV9XLX",
  "R$": "MessageAttachments.module__urlEmbedSpoiler___TV9XLX",
  "eb": "MessageAttachments.module__forwardedSourceButton___TV9XLX",
  "O_": "MessageAttachments.module__forwardedSourceLabel___TV9XLX",
  "wM": "MessageAttachments.module__forwardedSourceInfo___TV9XLX",
  "Lk": "MessageAttachments.module__forwardedSourceIcon___TV9XLX",
  "ZF": "MessageAttachments.module__forwardedSourceAvatar___TV9XLX",
  "qM": "MessageAttachments.module__forwardedSourceGuildIcon___TV9XLX",
  "T5": "MessageAttachments.module__forwardedSourceChevron___TV9XLX",
  "V0": "MessageAttachments.module__forwardedSourceName___TV9XLX",
  "ye": "MessageAttachments.module__stickersContainer___TV9XLX",
  "Bd": "MessageAttachments.module__stickerWrapper___TV9XLX",
  "Rq": "MessageAttachments.module__stickerWrapperInteractive___TV9XLX",
  "HF": "MessageAttachments.module__stickerImage___TV9XLX",
};

module.exports = exports;
